export const swe = {
    title: "Välkommen till Zamir Cohen´s React portfolio"
}

export const eng = {
    title: "Welcom to Zamir Cohen´s React portfolio"
}
